import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInput from "../../../../../dialogs/input";
import DialogInputBox from "../../../../../dialogs/inputbox";
import OptionSelect from "../../../../../dialogs/optionselect";
import RadioInput from "../../../../../dialogs/radioinput";

import { N19_TBL1,N19_TBL2,N19_TBL3,N19_TBL4 } from "./tbln19";
import React from "react";

import { getCurrentUserDatas } from "../../../../../../utils/software";
import { getCurrentProjectDatas } from "../../../../../../utils/software";

class ExportN19 extends ExportBase
{


constructor(props)
{
    
    super(props);
    console.log("creation avec ", props.stoponerror)
    this.state.formulaire =
    {
        originalprogram: "",
        translatedprogram:"",
        originalepisode:"",
        translatedepisode:"",  
        paysorigin:71,
        codelangue:15,        
        pagecode:1,
        codechar:0,
        translatorname:"",
        translatordetails:"",
        referencecode:"",
        level2: true,
        open:"0",
    }

    this.state.errorList = [] ;
        
    this.level2Ref = React.createRef();
    this.openRef = React.createRef();

    this.originalprogramRef = React.createRef();
    this.translatedprogramRef = React.createRef();
    this.originalepisodeRef = React.createRef();
    this.translatedepisodeRef = React.createRef();

    this.translatornameRef = React.createRef();
    this.translatordetailsRef = React.createRef();
    this.referencecodeRef = React.createRef();

    this.codecharRef = React.createRef();
    this.paysoriginRef = React.createRef();
    this.codelangueRef = React.createRef();
    this.pagecodeRef = React.createRef();


    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    return new Worker(new URL('./n19worker.js', import.meta.url));
}
showErrorList(errlist)
{
    this.setState({errorList: errlist});
}
sendFormulaire()
{
    var datas = {};

    datas.level2 = this.level2Ref.current.getValue();
    datas.open = this.openRef.current.getValue();

    datas.formulaire  = {};
    datas.formulaire.originalprogram = this.originalprogramRef.current.getValue();
    datas.formulaire.originalepisode = this.originalepisodeRef.current.getValue();
    datas.formulaire.translatedprogram = this.translatedprogramRef.current.getValue();
    datas.formulaire.translatedepisode = this.translatedepisodeRef.current.getValue();


    datas.formulaire.translatorname = this.translatornameRef.current.getValue();
    datas.formulaire.translatordetails = this.translatordetailsRef.current.getValue();
    datas.formulaire.referencecode = this.referencecodeRef.current.getValue();

    datas.formulaire.codechar = N19_TBL4[this.codecharRef.current.getValue()];
    datas.formulaire.paysorigin = N19_TBL1[this.paysoriginRef.current.getValue()];
    datas.formulaire.codelangue = N19_TBL2[this.codelangueRef.current.getValue()];
    datas.formulaire.pagecode = N19_TBL3[this.pagecodeRef.current.getValue()];
    datas.asset = this.state.asset;
    datas.francetv = this.props.stoponerror;


    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
        this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{

    var formulaire = this.state.formulaire;
    
    formulaire.originalprogram = asset.astitle;
    formulaire.originalepisode = asset.astitle;

    formulaire.translatorname = getCurrentUserDatas().datas.firstname+" "+getCurrentUserDatas().datas.lastname;
    formulaire.translatordetails = getCurrentUserDatas().datas.email;
    formulaire.referencecode = getCurrentProjectDatas().pjsherlock;

    

    this.setState({formulaire: formulaire})

    console.log("asset ", asset)

    this.originalprogramRef.current.setValue(asset.astitle)
    this.originalepisodeRef.current.setValue(asset.astitle)

    this.translatornameRef.current.setValue (formulaire.translatorname);
    this.translatordetailsRef.current.setValue (formulaire.translatordetails)
    this.referencecodeRef.current.setValue(formulaire.referencecode)

    
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>
    var diverrors = (<></>);
    var tousleserrors = [];
    
    if (this.state.errorList.length)
    {
        this.state.errorList.forEach( aerror =>{
            var color = "red";
            if (aerror.type === "warning") color="orange";

            tousleserrors.push(<><span style={{color:color}}>{this.context.language=="fr"?aerror.fr:aerror.en}</span><br/></>);
        }

        )

        diverrors =(<div 
            style={{fontSize:"13px", 
            borderStyle:"solid", 
            borderWidth:"1px", 
            borderRadius:"5px",
            marginTop:"10px",
            paddingLeft:"15px",
            paddingRight:"15px",
            paddingTop:"5px",
            paddingBottom:"10px",
            marginLeft:"2%",
            marginRight:"2%",
            width:"96%",

            borderColor:"#505050"}}
            >
            {tousleserrors}
        </div>)
    }

    return super.render(

    <>

        {diverrors}
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <RadioInput value={this.state.formulaire.open}
            title1={this.context.language=="fr"?"Exporter en sous-titrage télétexte (closed)":"Télétexte Export"}
            title2={this.context.language=="fr"?"Exporter en sous-titrage classique (Open)":"Open export"}
            ref = {this.openRef}
            onChange =  {this.handleOnChange}
            />

        <br/>
        <DialogInputBox
        value = {this.state.formulaire.level2}
        disabled={false}
        autoFocus = {false}
        ref = {this.level2Ref}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?"Niveau 2":"Level 2"}
        />


        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Entête":"Header"}
        />

        <DialogInput
        value = {this.state.formulaire.originalprogram}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.originalprogramRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre original du programme":"Original program title"}
        />

        <DialogInput
        value = {this.state.formulaire.translatedprogram}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatedprogramRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre traduit du programme":"Translated program title"}
        />


        <DialogInput
        value = {this.state.formulaire.originalepisode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.originalepisodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre original de l'épisode":"Original episode title"}
        />

        <DialogInput
        value = {this.state.formulaire.translatedepisode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatedepisodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre traduit de l'épisode":"Translated episode title"}
        />


        <DialogInput
        value = {this.state.formulaire.translatorname}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatornameRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Nom du traducteur":"Translator's name"}
        />

        <DialogInput
        value = {this.state.formulaire.translatordetails}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatordetailsRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Coordonnées traducteur":"Translator's contact details"}
        />

        <DialogInput
        value = {this.state.formulaire.referencecode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.referencecodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Code de référence sous-titres":"Subtitle list reference code"}
        />


        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Pays d'origine":"Country of originHeader"}
        />


        <OptionSelect
        value = {this.state.formulaire.paysorigin}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.paysoriginRef}
        selectname="paysorigin"
        width="96%"

        liste = {N19_TBL1}
        />

        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Code langue":"Language code"}
        />
        <OptionSelect
        value = {this.state.formulaire.codelangue}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.codelangueRef}
        selectname="codelangue"
        width="96%"

        liste = {N19_TBL2}
        />

        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Page de code":"Code page"}
        />
        <OptionSelect
        value = {this.state.formulaire.pagecode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.pagecodeRef}
        selectname="pagecode"
        width="96%"

        liste = {N19_TBL3}
        />

        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Code caractères":"Characters code"}
        />
        <OptionSelect
        value = {this.state.formulaire.codechar}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.codecharRef}
        selectname="codechar"
        width="96%"

        liste = {N19_TBL4}
        />
        <br/>
        <br/>
        
    </>
        
    )
}
}

export default ExportN19;